import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Spinner from '../../components/spinner/Spinner';
import RoutesApp from '../../routes';

//Servicios
import { ConfirmEmailService } from '../../services/api';

//Estilos
import './EmailConfirmation.css';

function EmailConfirmation() {
    const [loader, setLoader] = useState(false);
    const [confirmed, setConfirmed] = useState(false);

    const Params = useParams();

    // useEffect(() => {
    //     handleConfirmation();
    // }, []);

    const confirmationToken = Params.token;

    const handleConfirmation = async () => {
        try {
            setLoader(true);

            let res = await ConfirmEmailService.send({
                token: confirmationToken,
            });

            if (res) {
                setConfirmed(true);
            }

            setLoader(false);
        } catch (err) {
            toast(
                'El correo de confirmación ya no es válido: Por favor ingrese al sistema y pida un nuevo correo de confirmación',
                {
                    toastId: 'TOK03',
                    autoClose: false,
                    type: 'error',
                }
            );
            setLoader(false);
            return err;
        }
    };

    return loader ? (
        <Spinner />
    ) : (
        <div className="container-email_confirmation">
            {!confirmed && <h3>Confirme su correo</h3>}
            {confirmed && (
                <h3>
                    Su cuenta ha sido confirmada, haga clic{' '}
                    <Link to={RoutesApp.Login}>aquí</Link> para iniciar sesión.
                </h3>
            )}
            {!confirmed && (
                <button
                    className="btn btn-primary"
                    onClick={() => handleConfirmation()}
                >
                    Confirmar Correo
                </button>
            )}
        </div>
    );
}

export default EmailConfirmation;
